// One entry per test. To add a new test later: build its form (reports state via onReport),
// build an exporter (adds a sheet to the workbook), then add it here, and put its id in the rows it covers in materialCatalog.js (that decides which materials show it).
import { cbrExporter } from "./cbr/cbrExport";
import CBRTest from "./cbr/CBRTest";
import { fddExporter } from "./fdd/fddExport";
import FDDTest from "./fdd/FDDTest";
import { fsiExporter } from "./fsi/fsiExport";
import FSITest from "./fsi/FSITest";
import { gsaExporter } from "./gsa/gsaExport";
import GSATest from "./gsa/GSATest";
import { mddExporter } from "./mdd/mddExport";
import MDDTest from "./mdd/MDDTest";
import { llplExporter } from "./llplExport";
import LLPLTest from "./LLPLTest";

import { doneIdsFor, pendingFor } from "./materialCatalog";

// Materials come from the NABL scope — see materialCatalog.js. Which finished tests apply to which material is decided there too.
export { MATERIALS, GROUPS } from "./materialCatalog";

export const TESTS = [
  { id: 'llpl', label: 'Liquid & plastic limit', short: 'LL & PL', clause: 'IS 2720 (Part 5)',
    Form: LLPLTest, exporter: llplExporter },
  { id: 'gsa', label: 'Grain size analysis', short: 'GSA', clause: 'IS 2720 (Part 4)',
    Form: GSATest, exporter: gsaExporter },
  { id: 'fsi', label: 'Free swell index', short: 'FSI', clause: 'IS 2720 (Part 40)',
    Form: FSITest, exporter: fsiExporter },
  { id: 'mdd', label: 'Compaction (MDD / OMC)', short: 'MDD', clause: 'IS 2720 (Part 8)',
    Form: MDDTest, exporter: mddExporter },
  { id: 'cbr', label: 'California bearing ratio', short: 'CBR', clause: 'IS 2720 (Part 16)',
    Form: CBRTest, exporter: cbrExporter },
  { id: 'fdd', label: 'Field dry density (core cutter)', short: 'FDD', clause: 'IS 2720 (Part 29)',
    Form: FDDTest, exporter: fddExporter },
];

// Options for the Tests dropdown of one material: finished tests first (registry order), then scope tests that are still coming soon.
export function testsForMaterial(materialId) {
  if (!materialId) return [];
  const ids = doneIdsFor(materialId);
  const ready = TESTS.filter((t) => ids.includes(t.id));
  const soon = pendingFor(materialId).map((r, i) => ({
    id: `soon:${materialId}:${i}`, short: r.test, label: '', clause: r.clause, site: r.site, soon: true,
  }));
  return [...ready.map((t) => ({ ...t, site: false })), ...soon];
}
